import React, { useState } from "react";
import { Container, Button, Card , Spinner} from "react-bootstrap";

import PropTypes from "prop-types";
import { withRouter,Link} from "react-router-dom";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { getPolicies } from "../../store/policies/actions";


class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    this.props.getPolicies();
  }

  render() {
    const { data, loading } = this.props;

    return (
     <>
        {
        loading ? <div><Spinner animation="border" variant="secondary" /></div> :
        <Container>
            {data?.map(policy => (
             <Link key={policy.id} to={"term/"+policy.id} >
             <Card className="card-pointer"  >
                <Card.Body>
                  <Card.Title className="mb-2 text-muted">
                    {policy.title}
                  </Card.Title>
                </Card.Body>
              </Card>
              </Link>
            )) || "Nenhum termo"}
          </Container>
      }
      
      </>
    );
  }
}

Index.PropTypes = {
  t: PropTypes.any,
  history: PropTypes.any,
  loading: PropTypes.any,
  error: PropTypes.any,
  message: PropTypes.any,

  id: PropTypes.any,
  getPolicies: PropTypes.any,
  data: PropTypes.any,
  title: PropTypes.any,
  icon: PropTypes.any,
  content: PropTypes.any,
  show_menu: PropTypes.any,
};

const mapStateToProps = state => {
  const {
    id,
    loading,
    data,

    title,
    icon,
    content,
    show_menu,
  } = state.Policie;

  return {
    id,
    loading,
    data,

    title,
    icon,
    content,
    show_menu,
  };
};

export default withTranslation()(
  withRouter(connect(mapStateToProps, { getPolicies })(Index))
);
